//View Keys
import importSubUserModal from '../components/importSubUserModal/lan/es';

export default {
  ...importSubUserModal,
  subUser_title: "Usuarios",
  subUser_id: "ID",
  subUser_delete: "Eliminar",
  subUser_cancel: "Cancelar",
  subUser_manageUserTypes: "Administrar tipos de usuarios",
  subUser_userName: "Nombre de usuario",
  subUser_email: "Correo electrónico",
  subUser_groups: "Grupos",
  subUser_driverGroups: "Grupos de conductores",
  subUser_tags: "Etiquetas",
  subUser_formGroup: "Grupos de formularios",
  subUser_landmarkGroups: "Grupos Emblemáticos",
  subUser_permissions: "Permisos",
  subUser_expires: "Expira",
  subUser_expiryDate: "Fecha de caducidad",
  subUser_selectDate: "Seleccione la fecha",
  subUser_ipRestriction: "Restricción de IP",
  subUser_password: "Contraseña",
  subUser_confirmPassword: "Confirmar Contraseña",
  subUser_userType: "Tipo de usuario",
  subUser_select: "Seleccione",
  subUser_messageDelete: "Está seguro de que desea eliminar el/los usuario(s)",
  subUser_deleteUser: "Eliminar Usuario(s)",
  subUser_create: "Crear Usuario",
  subUser_edit: "Editar Usuario",
  subUser_createMessage: "Hemos enviado un correo electrónico para completar el registro del usuario. Solicite que revise su bandeja de entrada.",
  subUser_editMessage: "El usuario ha sido actualizado con éxito.",
  subUser_deleteMessage: "Usuario Eliminado",
  subUser_valueToCompareMessage: "Confirme que la contraseña coincida con la nueva contraseña",
  subUser_minMessageUsername: "El nombre de usuario debe contener un mínimo de caracteres:",
  subUser_minMessagePassword: "La constraseña debe contener un mínimo de caracteres:",
  subUser_maxMessagePassword: "La constraseña debe contener un máximo de caracteres:",
  subUser_minMessageConfirmPassword: "La confirmación de constraseña debe contener un mínimo de caracteres:",
  subUser_maxMessageConfirmPassword: "La confirmación de constraseña debe contener un máximo de caracteres:",
  subUser_maxMessageUsername: "El nombre de usuario debe contener un máximo de caracteres:",
  subUser_messageIpRestriction: "Dirección IP inválida",
  subUser_resetCognito: "Reiniciar",
  subUser_viewPermissions: "Ver permisos",
  subUser_resetUser: "Restablecer correo electrónico del usuario",
  subUser_resetPermissionMessage: "¿Está seguro que desea restablecer el correo electrónico del usuario?",
  subUser_successResetCognito: "Su dirección de correo electrónico se ha actualizado correctamente. Revise su bandeja de entrada para ver si recibió un correo electrónico de confirmación.",
  subUser_name: "Nombre",
  subUser_role: "Rol",
  subUser_firstName: "Nombres",
  subUser_lastName: "Apellidos",
  subUser_username: "Nombre de usuario",
  subUser_never: "Nunca",
  subUser_phone: "Celular",
  subUser_maxLengthMessageCellPhone: "El celular debe contener un máximo de caracteres:",
  subUser_minLengthMessageCellPhone: "El celular debe contener un mínimo de caracteres:",
  subUser_successPasswordReset: "Hemos enviado un enlace al correo del usuario para restablecer la contraseña.",
  subUser_resetPassword: "Restablecer contraseña del usuario",
  subUser_resetPasswordMessage: "¿Está seguro que desea restablecer la contraseña del usuario?",
  subUser_emailMessage: "El correo electrónico es invalido",
  subUser_minLengthMessageEmail: "El correo debe contener un mínimo de caracteres:",
  subUser_maxLengthMessageEmail: "El correo debe contener un máximo de caracteres:",
  subUser_apolloEldAccount: "Cuenta Apollo ELD",
  subUser_changePassword: "Cambiar la contraseña",
  subUser_resetEmail: "Reiniciar correo electrónico",
  subUser_resetPassword: "Reiniciar Contraseña",
  subUser_resendInvite: "Reenviar invitación",
  subUser_registrationStatus: "Estado de registro",
  subUser_subUser_notUpdated: "El usuario no se ha actualizado",
  subUser_subUser_invitationSent: "La invitación se ha enviado",
  subUser_import: "Importar"
};